export default "__VITE_ASSET__BGWkjMqs__"